export default {
	'assign-summary-sheet': {
		id: 'assign-summary-sheet',
		label: '分派汇总表',
		code: '0004_0006'
	}
}
